import React from 'react';
import ReactDOM from 'react-dom';
import EntryWrapper from '../EntryWrapper';
import ErrorBoundry from '../components/common/ErrorBoundry';
import LimitBanner from '../components/limitBanner/LimitBanner';

const rootElement = document.getElementById('limit-banner-root');

if (rootElement) {
  ReactDOM.render(
    <EntryWrapper>
      <ErrorBoundry>
        <LimitBanner />
      </ErrorBoundry>
    </EntryWrapper>,
    rootElement
  );
}